import { CSSObjectWithLabel } from 'react-select';

export const getdropDownCommonStyling = (disabled: boolean) => ({
  border: disabled ? 'none' : '1px solid #828D98',
  borderRadius: '3px',

  '.ag-dropdown__control': {
    height: '30px',
    alignContent: 'center'
  },

  '&:focus-within': {
    padding: '2px',
    borderRadius: '5px',
    border: '2px solid #0075C9',
  }

}) as CSSObjectWithLabel;